import { prop } from 'ramda';
import Model from './Model';
import Mixable, { identifiable, paginatable } from './mixins';

export default class Inventory extends Mixable(Model).implementing(
  identifiable(prop('id')),
  paginatable((api) => api.inventory.getInventoryProducts),
) {}
